import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';

import { STATIC_ROOT } from '../../constants';

import Tooltip from '../tooltip/Tooltip';
import SvgComponent from '../SvgComponent';
import ButtonComponent from '../button/ButtonComponent';

import './InformativeModal.scss';

class InformativeModal extends React.Component {
    handleConfirm = () => this.props.onConfirm && this.props.onConfirm();

    render() {
        const { i18n } = this.props;

        const i18nInstructions = i18n.INSTRUCTIONS;

        const instructions = [
            <div className="instruction">
                <p>{i18nInstructions.COOKIES}</p>
                <Tooltip text={i18nInstructions.COOKIES_TOOLTIP}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/info.svg`}
                        height="16"
                        className="information-badge"
                        aria-hidden="true"
                        focusable="false"
                    />
                    <span className="sr-only">{i18n.ACCESSIBILITY.TOOLTIP_DESCRIPTION}</span>
                </Tooltip>
            </div>,
            <div className="instruction">
                <p>{i18nInstructions.CONDITIONS}</p>
            </div>,
            <div className="instruction">
                <p>{i18nInstructions.TAB}</p>
            </div>,
            <div className="instruction">
                <p>{i18nInstructions.AD_BLOCKER}</p>
            </div>,
            <div className="instruction">
                <p>{i18nInstructions.MOBILE_APP}</p>
            </div>
        ];

        return (
            <div className="informative-modal">
                <h1>{i18n.TITLE}</h1>
                <h2 className="instruction-list-title">{i18n.INSTRUCTIONS_TITLE}</h2>
                <ul className="instruction-list">
                    {instructions.map((instruction, i) => (
                        <li className="list-item" key={i}>
                            <div className="list-bullet">
                                <span>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/check.svg`}
                                        width="24"
                                        height="24"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                </span>
                            </div>
                            {instruction}
                        </li>
                    ))}
                </ul>
                <p className="italic">{i18n.CONFIRMATION_MAIL}</p>
                <ButtonComponent
                    onClick={this.handleConfirm}
                    text={i18n.CONFIRMATION_BUTTON}
                    color="main"
                />
            </div>
        );
    }
}

InformativeModal.propTypes = {
    onConfirm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.INFORMATIVE_MODAL
});

export default withRouter(connect(mapStateToProps)(InformativeModal));



// WEBPACK FOOTER //
// ./src/components/informativemodal/InformativeModal.js